import styled from 'styled-components';

export const Dots = styled.div<{ $flat?: boolean; $inline?: boolean }>`
  display: grid;
  grid-gap: 11px;
  justify-content: flex-start;
  ${({ $flat }) => $flat && 'grid-template-columns: repeat(5, auto)'};
  ${({ $inline }) => $inline && 'grid-template-columns: repeat(3, auto); grid-gap: 20px;'}

  .separator {
    width: 1px;
    height: 11px;
    background: ${({ theme }) => theme.colors.stroke};
    transform: scaleY(2);
  }

  .item {
    display: grid;
    grid-template-columns: 20px 1fr;
    align-items: center;

    .item__dot {
      width: 13px;
      height: 13px;
      border-radius: 50%;
      &--base {
        background: ${({ theme }) => theme.colors.prussianBlue};
      }
      &--live {
        background: ${({ theme }) => theme.colors.gp1};
      }
      &--complete {
        background: ${({ theme }) => theme.colors.brightBlue};
      }
    }

    &__label {
      margin: 0 !important;
      line-height: 80%;
    }
  }
`;
